import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { StyledImage, StyledDiv } from './flags/CurrencyStyle';

const CurrencyFlagDynamicImage = props => {
  const { flagCode } = props;

  const handleFlag = code => {
    try {
      return require(`./flags/${code}.png`);
    } catch {
      return null;
    }
  };
  const imageSource = useMemo(() => handleFlag(flagCode), [flagCode]);
  if (imageSource == null) return <StyledDiv />;

  return <StyledImage src={imageSource} />;
};
CurrencyFlagDynamicImage.propTypes = {
  flagCode: PropTypes.string.isRequired
};
export default CurrencyFlagDynamicImage;
